<!--|| this.dateTooltipPlace == 2-->
<span class="input-group-append"  [ngClass]="[(this.dateTooltipPlace == 1 ) ? 'input-tooltip-icon-member':'input-tooltip-icon-'+ popupStyle]">
    <span class="input-group-text" [ngClass]="{'border-warning': showWarning,'input-tooltip-span':fieldEnabled,'input-tooltip-span-disbled':!fieldEnabled }">
        <!-- Tooltip icon in input field -->
        <img *ngIf="!showWarning && fieldEnabled" class="input-tooltip-img" src="../../../../assets/multimedia-module/question-tooltip-icon.png" (click)=showHideTooltip()>
        <img  *ngIf="showWarning" class="input-tooltip-img" src="../../../../assets/multimedia-module/warning-tooltip-icon.png" (click)=showHideTooltip()>
        <img *ngIf="!fieldEnabled && !showWarning" class="input-tooltip-img" src="../../../../assets/multimedia-module/question-tooltip-icon-disable.png" (click)=showHideTooltip()>

        <!-- Multimedia Upload page -->
        <!-- Show tooltip message (info or warning) for date input in media upload page according to position that's shown -->

        <!-- <div *ngIf="isVisible && this.dateTooltipPlace == 0" [ngClass]="{'tooltip-top':this.tooltipPosition == 0,'tooltip-bottom':this.tooltipPosition == 1,
        'tooltip-left':this.tooltipPosition == 2,'tooltip-right':this.tooltipPosition == 3}"> -->

        <div *ngIf="isVisible && this.dateTooltipPlace == 0"
        [ngClass]="[(this.tooltipPosition == 0) ? 'tooltip-top-'+popupStyle : '' ,
                    (this.tooltipPosition == 1) ? 'tooltip-bottom' : '',
                    (this.tooltipPosition == 2) ? 'tooltip-left' : '',
                    (this.tooltipPosition == 3) ? 'tooltip-right' : '' ]">

            <img class="close-button" src="../../../../assets/multimedia-module/close-icon.png" (click)="showHideTooltip()">
            <div class="row">
                <div class="tooltip-header-icon">
                    <img style="width: 64%;" src="../../../../assets/multimedia-module/icon-tooltip.png">
                </div>
                <div class="tooltip-header">
                   <span style="font-size: 1.2em;">{{"lbl_notice" | translate}}</span>
                </div>
            </div>
            <div class="row">
                <p *ngIf="showWarning" class="tooltip-validation">{{"val_date_tooltip_validation_upper"| translate}}</p>
                <p>{{"val_date_tooltip_content"| translate}}</p>
            </div>
        </div>

        <!-- Member Editor Birth -->
        <!-- Show tooltip message (info or warning) for date inputs in media upload page according to position that's shown -->
        <div *ngIf="isVisible && this.dateTooltipPlace == 1"
        [ngClass]="{'tooltip-right-member':(this.tooltipPosition == 3 && !this.isExpand && !this.showWarning), 'tooltip-right-expand':(this.tooltipPosition == 3 && this.isExpand && !this.showWarning),
         'tooltip-right-member-error':(this.tooltipPosition == 3 && !this.isExpand && this.showWarning),'tooltip-right-member-error-expand':(this.tooltipPosition == 3 && this.isExpand && this.showWarning) }">
            <img class="close-button" src="../../../../assets/multimedia-module/close-icon.png" (click)="showHideTooltip()">
            <div class="row">
                <div class="tooltip-header-icon">
                    <img style="width: 64%;" src="../../../../assets/multimedia-module/icon-tooltip.png">
                </div>
                <div class="tooltip-header">
                   <span style="font-size: 1.2em;">{{"lbl_notice" | translate}}</span>
                </div>
            </div>
            <div class="row">
                <p *ngIf="showWarning" class="tooltip-validation">{{"val_date_tooltip_validation_upper"| translate}}</p>
                <p>{{"val_date_tooltip_content"| translate}}</p>
            </div>
        </div>
    </span>
</span>
